// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3uKz6","header":"MergedInvoice_header__1zIa9"};